import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreditIcon from '../CreditIcon';
import InjuryIcon from '../InjuryIcon';

export default function FactionCardRoster({
  faction,
  ownerName,
  members = [],
  highlighted = false,
  showScore = true
}) {
  const navigate = useNavigate();

  // Calcolo punteggio totale (se non passato direttamente)
  const totalScore = faction.totalScore ?? 0;

  // Formatta proprietario (tronca se troppo lungo)
  const formattedOwnerName = ownerName?.length > 20
    ? `${ownerName.substring(0, 18)}...`
    : ownerName ;

return (
  <div
    className={`card h-100 border-0 cursor-pointer d-flex flex-column overflow-hidden faction-card-roster ${
      highlighted ? 'faction-card-roster-highlighted' : ''
    }`}
    onClick={() => navigate(`/factions/${faction.id}`)}
  >
    {/* Accent bar superiore */}
    <div className="faction-card-roster-accent" />

    {/* Header: nome + proprietario + punteggio */}
    <div className="card-header bg-transparent border-0 pb-0 pt-3 px-3 faction-card-roster-header">
      <div className="d-flex justify-content-between align-items-start gap-2">
        <div className="flex-grow-1 min-w-0">
          <h6
            className="fw-bold mb-1 text-truncate faction-card-roster-title"
            title={faction.name}
          >
            {faction.name}
          </h6>
          <div className="d-flex align-items-center gap-1 flex-wrap faction-card-roster-owner-row">
            <small className="text-brand-muted text-truncate faction-card-roster-faction-card-roster" style={{ maxWidth: '130px' }}>
              {formattedOwnerName}
            </small>
          </div>
        </div>

        {showScore && (
          <div className="text-end flex-shrink-0 faction-card-roster-scorebox">
            <div className="text-brand-muted small mb-0 faction-card-roster-scorelabel">Punteggio</div>
            <div
              className={`h4 mb-0 fw-bold faction-card-roster-score text-brand-secondary ${
                totalScore >= 0 ? 'faction-card-roster-score-positive' : 'faction-card-roster-score-negative'
              }`}
            >
              {totalScore}
            </div>
          </div>
        )}
      </div>
    </div>

    {/* Corpo: wrestler in avatar group (responsive) */}
    <div className="card-body pt-1 px-3 pb-1 d-flex flex-column justify-content-center">
      {members.length > 0 ? (
        <div className="mt-1 position-relative">
          <div className="d-flex align-items-center flex-wrap faction-card-roster-avatars">
            {members.slice(0, 8).map((wrestler, index) => (
              <div
                key={wrestler.id || index}
                className="position-relative faction-card-roster-avatar-wrap"
                style={{
                  marginLeft: index > 0 ? '-12px' : '0',
                  zIndex: 10 - index,
                }}
                title={`${wrestler.name}${wrestler.isInjured ? ' (Infortunato)' : ''}`}
              >
                {wrestler.imageUrl ? (
                  <div className="position-relative">
                    <img
                      src={wrestler.imageUrl}
                      alt={wrestler.name}
                      className="rounded-circle shadow-sm faction-card-roster-avatar"
                    />
                    {wrestler.isInjured && (
                      <InjuryIcon
                        size={20}
                        iconSize="0.9rem"
                        className="position-absolute bottom-0 end-0 faction-card-roster-injury"
                      />
                    )}
                  </div>
                ) : (
                  <div
                    className="rounded-circle border border-2 d-flex align-items-center justify-content-center faction-card-roster-avatar faction-card-roster-avatar-placeholder"
                  >
                    <i className="bi bi-person-fill faction-card-roster-avatar-icon" />
                  </div>
                )}
              </div>
            ))}

            {members.length > 8 && (
              <div
                className="position-relative"
                style={{ marginLeft: '-12px', zIndex: 1 }}
              >
                <div
                  className="rounded-circle border border-2 d-flex align-items-center justify-content-center fw-bold faction-card-roster-avatar faction-card-roster-avatar-more"
                  title={`+${members.length - 8} altri`}
                >
                  +{members.length - 8}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="d-flex flex-column align-items-center justify-content-center py-3 faction-card-roster-empty">
          <div className="rounded-circle d-flex align-items-center justify-content-center mb-2 faction-card-roster-empty-icon-wrap">
            <i className="bi bi-people-fill fs-4" />
          </div>
          <small className="text-light-emphasis faction-card-roster-empty-text">Nessun wrestler</small>
        </div>
      )}
    </div>

    {/* Footer: crediti */}
    <div className="card-footer bg-transparent border-0 pt-0 pb-3 px-3 d-flex justify-content-end align-items-center faction-card-roster-footer">
      <div className="d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill shadow-sm faction-card-roster-credits">
        <CreditIcon size={14} color="white" />
        <span>{faction.creditsLeft ?? 0}</span>
      </div>
    </div>
  </div>
);
}
